var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0001 11.474C22.0001 10.5511 21.9252 9.8776 21.7632 9.1792H11.2246V13.3447H17.4105C17.2858 14.3799 16.6124 15.9388 15.1157 16.9864L15.0948 17.1258L18.4269 19.7072L18.6577 19.7302C20.7778 17.7721 22.0001 14.8912 22.0001 11.474Z",
    fill: "#4F81E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.2245 22.4489C14.2551 22.4489 16.7993 21.4511 18.6576 19.73L15.1156 16.9862C14.1678 17.6472 12.8957 18.1087 11.2245 18.1087C8.25627 18.1087 5.73701 16.1507 4.83897 13.4443L4.70734 13.4555L1.24258 16.1369L1.19727 16.2629C3.04305 19.9295 6.83444 22.4489 11.2245 22.4489Z",
    fill: "#55A059"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.83895 13.4444C4.602 12.746 4.46486 11.9976 4.46486 11.2244C4.46486 10.4511 4.602 9.70286 4.82649 9.00445L4.82021 8.85571L1.31203 6.13123L1.19725 6.18582C0.436513 7.70738 0 9.41603 0 11.2244C0 13.0328 0.436513 14.7414 1.19725 16.2629L4.83895 13.4444Z",
    fill: "#E9B840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.2245 4.34011C13.3322 4.34011 14.7539 5.25053 15.5646 6.01136L18.7324 2.91837C16.7869 1.10998 14.2551 0 11.2245 0C6.83444 0 3.04305 2.51925 1.19727 6.18589L4.8265 9.00452C5.73701 6.29818 8.25627 4.34011 11.2245 4.34011Z",
    fill: "#D14E3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.552ea88c3534ef010c05c95ee3b8c6a6.svg";
export { ForwardRef as ReactComponent };